import React, {useEffect, useState} from "react";
import {Alert, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import Lottie from 'react-lottie-player';
// Formik Validation
import * as Yup from "yup";
import {useFormik} from "formik";

// action
import {apiError, registerUser} from "../../store/actions";

//redux
import {useDispatch, useSelector} from "react-redux";

import {Link} from "react-router-dom";

import {commonDomains} from "../../constants/email_validation";

// import images
import refreshResourcesLottie from '../../assets/images/refresh_resources_lottie.json';
import Select from "react-select";
import countryCodes from "../Organization/CountryCode";

const Register = props => {

  //meta title
  document.title = "Temperstack | Register";

  const [passwordShown, setPasswordShown] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  function handleSelectGroup(selectedGroup) {
    setSelectedGroup(selectedGroup);
  }

  const optionGroup = [
    {
      label: "Country Code",
      options: countryCodes
    },
  ];

  const dispatch = useDispatch();

  const validateFunction = async (values) => {
    let errors = {}
    let subdomain = values.org_name;
    if (subdomain.length > 0) {
      let regex = /^[a-z0-9]+$/i;
      if (!regex.test(subdomain)) {
        errors['org_name'] = 'Subdomain cannot have spaces or special characters'
      }
    }
    let email_split = values.email.split("@")
    if (email_split.length === 2) {
      let email_domain = email_split[1]
      if (commonDomains.includes(email_domain)) {
        errors['email'] = 'Please enter work email'
      }
    }
    let password_format =  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,30}$/;
    if (!password_format.test(values.password)) {
      errors['password'] = 'Password should be at least 8 characters and should contain lowercase letters, uppercase letters, numeric digits and special characters';
    }
    return errors
  }

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    validate: validateFunction,

    initialValues: {
      email: '',
      org_name: '',
      password: '',
      name: '',
      phone_number: ''
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .required("Please Enter Your Email"),

      org_name: Yup.string()
        .matches(/^[a-zA-Z0-9]+$/, "Organization name can only contain letters and numbers")
        .max(128, "Organization name cannot exceed 128 characters")
        .required("Please Enter Your Organization name"),

      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[!@#$%^&*]/, "Password must contain at least one special character")
        .required("Please Enter Your Password"),

      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
        .max(128, "Name cannot exceed 128 characters")
        .test('not-only-spaces', 'Name cannot be only spaces', value => {
          return value && value.trim().length > 0;
        })
        .required("Please Enter Your Name"),

      phone_number: Yup.string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(10, "Phone number must be at least 10 digits")
        .max(15, "Phone number can't exceed 15 digits")
        .required("Please Enter Your Phone Number")
    }),
    onSubmit: (values) => {
      const payload = {...values};
      payload['name'] = values['name'].trim();
      payload['phone_number'] = selectedGroup.value + values['phone_number'];
      dispatch(registerUser(payload));
    }
  });

  const {user, registrationError, loading} = useSelector(state => ({
    user: state.Account.user,
    registrationError: state.Account.registrationError,
    loading: state.Account.loading,
  }));

  useEffect(() => {
    dispatch(apiError(""));
  }, []);

  return (
    <React.Fragment>
      <div className="my-3 pt-sm-3 scrollable-container">
        <Container fluid>
          <Row className="justify-content-center why-bluejay">
            <Col lg={8} className="mt-4">
                <CardBody className="pt-0">
                  <Row>
                      <h4 className="text-white mt-4 why-bluejay-font">Never miss an Alert with Temperstack!</h4>
                      <Col lg="6" className="">
                        <h5 className="why-bluejay no-background">
                          Sign up for an account today and get:</h5>
                          <ul className="mt-4">
                            <li className="mt-2 text-white">Out-of-box Cross-platform Integrations</li>
                            <li className="mt-2 text-white">Automated Continuous Audit</li>
                            <li className="mt-2 text-white">Automated Alerts setup</li>
                          </ul>
                      </Col>
                      <Col lg="4" className="scan-animation">
                          <Lottie
                              loop
                              animationData={refreshResourcesLottie}
                              play
                              //style={{ width: 250, height: 250 }}
                          />
                      </Col>
                    </Row>
                </CardBody>
            </Col>
            <Col lg={4} className="mt-4">
              <Card className="overflow-hidden mt-4">
                <CardBody className="">
                  <h3>Register</h3>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {user && user ? (
                        <Alert color="success">
                          Success! Please check your email to verify your account
                        </Alert>
                      ) : null}

                      {registrationError && registrationError ? (
                        <Alert color="danger">{registrationError}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label">Choose a subdomain</Label>
                        <div className="input-org">
                          <Input
                            name="org_name"
                            type="text"
                            className="input-no-border input"
                            placeholder="Organization"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.org_name || ""}
                            invalid={
                              validation.touched.org_name && validation.errors.org_name ? true : false
                            }
                          />
                          <span className="subdomain-label border-start">.temperstack.com</span>
                        </div>
                        <div className="invalid-error">{validation.errors.org_name}</div>
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Input
                          id="name"
                          name="name"
                          className="form-control input"
                          placeholder="Enter Your Name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={(e) => {
                            if (e.target.value) {
                              validation.setFieldValue('name', e.target.value.trim());
                            }
                            validation.handleBlur(e);
                          }}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name ? true : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Work Email</Label>
                        <Input
                          id="email"
                          name="email"
                          className="input"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Phone Number</Label>
                        <Row>
                          <Col md="4">
                            <Label style={{fontSize: 'smaller'}}>Country Code</Label>
                            <Select
                              value={selectedGroup}
                              onChange={(selectedValue) => {
                                handleSelectGroup(selectedValue);
                              }}
                              options={optionGroup}
                              className="select2-selection"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  neutral0: '#222736',
                                  neutral5: '#485EC4',
                                  neutral10: '#485EC4',
                                  neutral60: '#ffffff',
                                  neutral70: '#ffffff',
                                  neutral80: '#ffffff',
                                  neutral90: '#ffffff',
                                  primary: '#485EC4',
                                },
                              })}
                              styles={customStyles}
                              required
                            />
                          </Col>
                          <Col md="8">
                            <Label style={{fontSize: 'smaller'}}>Number</Label>
                            <Input
                              id="phone_number"
                              name="phone_number"
                              className="input"
                              placeholder="Enter phone number"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.phone_number || ""}
                              invalid={
                                validation.touched.phone_number && validation.errors.phone_number ? true : false
                              }
                            />
                            {validation.touched.phone_number && validation.errors.phone_number ? (
                              <FormFeedback type="invalid">{validation.errors.phone_number}</FormFeedback>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                      {/*<div className="mb-3">*/}
                      {/*  <Label className="form-label">Phone Number</Label>*/}
                      {/*  <div className="mb-3 custom-flex-item">*/}
                      {/*    <Select*/}
                      {/*      value={selectedGroup}*/}
                      {/*      onChange={(selectedValue) => {*/}
                      {/*        handleSelectGroup(selectedValue);*/}
                      {/*      }}*/}
                      {/*      options={optionGroup}*/}
                      {/*      className="select2-selection"*/}
                      {/*      theme={(theme) => ({*/}
                      {/*        ...theme,*/}
                      {/*        borderRadius: 0,*/}
                      {/*        colors: {*/}
                      {/*          ...theme.colors,*/}
                      {/*          neutral0: '#222736',*/}
                      {/*          neutral5: '#485EC4',*/}
                      {/*          neutral10: '#485EC4',*/}
                      {/*          neutral60: '#ffffff',*/}
                      {/*          neutral70: '#ffffff',*/}
                      {/*          neutral80: '#ffffff',*/}
                      {/*          neutral90: '#ffffff',*/}
                      {/*          primary: '#485EC4',*/}
                      {/*        },*/}
                      {/*      })}*/}
                      {/*      styles={customStyles}*/}
                      {/*      required*/}
                      {/*    />*/}
                      {/*  </div>*/}
                      {/*  <div className="mb-3 custom-flex-item">*/}
                      {/*    <Input*/}
                      {/*      id="phone_number"*/}
                      {/*      name="phone_number"*/}
                      {/*      className="input"*/}
                      {/*      placeholder="Enter phone number"*/}
                      {/*      type="text"*/}
                      {/*      onChange={validation.handleChange}*/}
                      {/*      onBlur={validation.handleBlur}*/}
                      {/*      value={validation.values.phone_number || ""}*/}
                      {/*      invalid={*/}
                      {/*        validation.touched.phone_number && validation.errors.phone_number ? true : false*/}
                      {/*      }*/}
                      {/*    />*/}
                      {/*    {validation.touched.phone_number && validation.errors.phone_number ? (*/}
                      {/*      <FormFeedback type="invalid">{validation.errors.phone_number}</FormFeedback>*/}
                      {/*    ) : null}*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <div className="input-org">
                          <Input
                            name="password"
                            className="input-no-border input"
                            type={passwordShown ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {
                            passwordShown ?
                              <i className="password-label fa fa-eye-slash me-2 input-label"
                                 onClick={togglePassword}></i>
                              :
                              <i className="password-label fa fa-eye me-2 input-label" onClick={togglePassword}></i>
                          }
                        </div>
                        <div className="invalid-error">{validation.errors.password}</div>
                      </div>
                      <div className="mt-4 text-center">
                        <button
                          className="btn btn-primary w-md"
                          type="submit"
                        >
                          Create Account
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-2 text-center">
                <p className="mb-0">
                  By creating an account, you are agreeing to the{" "}
                  <Link to="https://www.temperstack.com/terms-of-use" className="text-primary">
                    Temperstack Terms of Use
                  </Link>
                </p>
              </div>
              <div className="mt-2 mb-4 text-center text-white">
                <h5>
                  Already have an account?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </h5>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;
